import React, { JSX, memo } from 'react';

import { ColorValue, View } from 'react-native';

import { EPGProgram } from 'custom_modules/react-native-epg';

import { CellItem, Layout } from './types';

type ItemContainerProps<T = unknown> = {
    data: CellItem<T>;
    layout: Layout;
    backgroundColor: ColorValue;
    childRenderer: (
        data: CellItem<T>,
        layout: Layout,
    ) => JSX.Element | JSX.Element[] | null;
    hasTVPreferredFocus?: boolean;
};

function ItemContainer<T>({
    data,
    layout,
    backgroundColor,
    childRenderer,
    hasTVPreferredFocus,
}: ItemContainerProps<T>) {
    return (
        <View
            style={{
                position: 'absolute',
                left: layout.x,
                top: layout.y,
                height: layout.height,
                width: layout.width,
                backgroundColor,
                zIndex: layout.x,
            }}
            hasTVPreferredFocus={hasTVPreferredFocus}
        >
            {childRenderer(data, layout)}
        </View>
    );
}

export default memo(ItemContainer, (prevProps, nextProps) => {
    const obligateCheck =
        prevProps.data.id === nextProps.data.id &&
        prevProps.childRenderer === nextProps.childRenderer;

    if (typeof nextProps.data.program?.extra?.propsAreEqual === 'function') {
        return (
            obligateCheck &&
            nextProps.data.program.extra.propsAreEqual(
                prevProps.data.program,
                nextProps.data.program,
            )
        );
    }

    return obligateCheck;
});
